import React from 'react';
import './GenderRadio.scss'; // Import CSS for styling

const GenderRadio = ({ label, value, name, checked, onChange,
  selectedIcon = `/images/registration/${value == 'male' ? 'GenderMaleSelected' : 'GenderFemaleSelected'}.svg`,
  unselectedIcon = `/images/registration/${value == 'male' ? 'GenderMale' : 'GenderFemale'}.svg` }) => {
  return (
    <label className="custom-radio">
      <input
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
      />
      {(selectedIcon || unselectedIcon) && <span className="radio-icon">
        {checked ? (
          <img src={selectedIcon} alt="Selected" />
        ) : (
          <img src={unselectedIcon} alt="Unselected" />
        )}
      </span>}
      <span className="radio-label">{label}</span>
    </label>
  );
};

export default GenderRadio;
